<template>
  <v-container class="py-0 max-width-1200">
    <v-row class="text-left justify-center">

      <v-col cols="12" sm="8" class="px-6 max-width-700 mr-auto border-right-light">
        <v-row>
          <v-col class="pb-0 display-3">
            {{ $t('contact.subtitle') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            {{ $t('contact.text') }}
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="pt-8">
            <div class="arrow light"></div>
          </v-col>
        </v-row> -->
      </v-col>

      <v-col cols="12" sm="4" class="px-6" style="min-width:330px">
        <v-col class="justify-end text-end">
          <img
            src="@/assets/logo-flat-light.svg"
            loading="lazy"
            alt="Rubin Infomatika logó"
            height="200" width="200">
        </v-col>
        <v-col>
          <v-row>
            <v-col class="pb-0 text-end text-uppercase" style="font-size:18px">
              Rubin Informatikai Zrt.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 pt-1 text-end">
              1149 Budapest, Egressy út 17-21.
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col class="pb-0 pt-1 text-end mouse-hover-link" @click="openPhone('+3614694020')">
              +36 1 469 40 20
            </v-col>
          </v-row> -->
          <v-row>
            <v-col id="showPhoneNumberSpan" v-if="!showPhoneNumber" class="pb-0 pt-1 text-end mouse-hover-link" @click="toggleShowPhoneNumber()">
              {{ $t("common.showPhoneNumber") }}
            </v-col>
            <v-col id="phoneNumberSpan" v-if="showPhoneNumber" class="pb-0 pt-1 text-end mouse-hover-link" @click="openPhone('+3614694020')">
              +36 1 469 40 20
            </v-col>
          </v-row>
        </v-col>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Contact',
    extends: DataComponentBase,

    data: () => ({
    }),

    methods: {
      openPhone(phoneNumber) {
        window.location ='tel:' + phoneNumber;
      },
    }
  }
</script>
